import { render, staticRenderFns } from "./nav-list.vue?vue&type=template&id=52de015f&scoped=true&"
import script from "./nav-list.vue?vue&type=script&lang=js&"
export * from "./nav-list.vue?vue&type=script&lang=js&"
import style0 from "./nav-list.vue?vue&type=style&index=0&id=52de015f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de015f",
  null
  
)

export default component.exports